import { Box, Breadcrumbs, Icon, IconButton, Fab, Badge, SvgIcon } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
	Route,
	Switch,
	Link as RouterLink
} from "react-router-dom";
import Assets from './Assets/index';
import Contracts from './Contracts/index';
import Iot from './IoT/index';

function ListView(props) {
	const routes = ["/assets-dashboard", "/contracts-dashboard", "/iot-dashboard"];
	const getLastItem = thePath => thePath.substring(thePath.lastIndexOf('/') + 1).replace('-', ' ');


	return (
		<div>
			<Route
				path="/"
				render={(history) => (
					<>
						<div role="presentation" className="cstm_breadcrumbs_holder">
							<Breadcrumbs aria-label="breadcrumb">
								<span className='dashboard_breadcrumb' style={{ marginRight: '3px' }}>Dashboard </span>
								<span className='dashboard_breadcrumbTwo'>{getLastItem(history.location.pathname)}</span>
								<span className='dashboard_breadcrumbTwo'>
									{/* <IconButton
					// style={{ position: 'absolute', right: '0px', top: '0px' }}
					onClick={() => {
										// close()
										
					}}>
					<Icon>chatbot</Icon>
									</IconButton> */}
									{/* <Fab 
									onClick={() => {
										window.open("/dalos-ai", "_blank");
									}}
									>
										<SvgIcon>
											<path d="M20 2H4a2 2 0 00-2 2v14l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2z" />
										</SvgIcon>
									</Fab> */}
								</span>
							</Breadcrumbs>
						</div>
						<Box className='cstm_tabs_holder'>
							<Tabs
								className='tabs_main_holder'
								value={
									history.location.pathname !== "/"
										? history.location.pathname
										: false
								}
							>
								<Tab
									className='each_tab_holder'
									label="Assets"
									value={routes[0]}
									component={RouterLink}
									to={routes[0]}
								/>
								<Tab
									className='each_tab_holder'
									label="Contracts"
									value={routes[1]}
									component={RouterLink}
									to={routes[1]}
								/>
								<Tab
									className='each_tab_holder'
									label="IoT"
									value={routes[2]}
									component={RouterLink}
									to={routes[2]}
								/>
							</Tabs>
						</Box>
					</>
				)}
			/>
			<Switch>
				<Route path="/assets-dashboard" component={Assets} />
				<Route path="/contracts-dashboard" component={Contracts} />
				<Route path="/iot-dashboard" component={Iot} />
			</Switch>
		</div>
	);
}
export default ListView